(function () {
  function insertSectionCartDrawer() {
    // Die Upsells stehen inzwischen fest im Drawer-Markup (cart-drawer.liquid),
    // direkt unter den Artikeln. Ist der Block da, darf nichts nachgeschoben
    // werden, sonst steht er doppelt drin.
    if (document.querySelector('#CartDrawer #cart-drawer-upsell')) return;

    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;
    if (cartDrawerItems.classList.contains('is-empty')) return;

    var upsells = document.querySelector('#cart-drawer-upsell-wrapper');
    if (!upsells) return;

    cartDrawerItems.insertAdjacentHTML('beforeend', upsells.innerHTML);

    if (!cartDrawerItems.querySelector('.cart-drawer-upsell-list li')) {
      var upsellEl = cartDrawerItems.querySelector('#cart-drawer-upsell');
      if (upsellEl) upsellEl.remove();
    }
  }

  insertSectionCartDrawer();

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault();
    var opt = select.options[select.selectedIndex];
    var card = select.closest('.cart-drawer-upsell-list-item');

    var imgSrc = opt.dataset.variantImg;
    if (imgSrc) {
      var img = card.querySelector('.cart-drawer-upsell-list-item-left img');
      img.src = imgSrc;
    }

    // Preis in der Karte auf die gewaehlte Variante ziehen.
    var price = card.querySelector('.pv-upsell-price');
    if (price && opt.dataset.variantPrice) {
      price.textContent = opt.dataset.variantPrice;
    }
  };

  // Fetch only the cart-drawer section (not the full page) and refresh the upsell wrapper.
  var refreshInFlight = false;
  function refreshUpsellFromServer() {
    if (refreshInFlight) return;
    refreshInFlight = true;

    var url = window.location.pathname + '?sections=cart-drawer';
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newUpsell = doc.querySelector('#cart-drawer-upsell-wrapper');
        var oldUpsell = document.querySelector('#cart-drawer-upsell-wrapper');
        if (!newUpsell || !oldUpsell) return;

        oldUpsell.replaceWith(newUpsell);

        var existing = document.querySelector('#CartDrawer cart-drawer-items #cart-drawer-upsell');
        if (existing) existing.remove();
        insertSectionCartDrawer();
      })
      .catch(function () {})
      .finally(function () { refreshInFlight = false; });
  }

  // React to cart updates via the theme's pub/sub system — no DOM polling.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Re-inject immediately so the upsell stays visible after renderContents wipes #CartDrawer.
      insertSectionCartDrawer();
      // Then refresh from server so the upsell list excludes products now in the cart.
      refreshUpsellFromServer();
    });
  }

  // Also re-inject on cart drawer open in case sections were replaced without a cart-update event.
  document.addEventListener('cart:open', insertSectionCartDrawer);

  // Cart page: refresh upsell when cart items change.
  function listenCartPage() {
    var cartItems = document.querySelector('#MainContent .cart__items');
    if (!cartItems) return;
    // Subscribe-based refresh already handles cart updates; nothing else needed.
  }
  listenCartPage();
})();
